import { Component, OnDestroy, ViewEncapsulation } from "@angular/core";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Subject, takeUntil } from "rxjs";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Company } from "src/app/models/Company";
import { Department } from "src/app/models/Department";
import { DepartmentFilterType } from "src/app/models/DepartmentFilterType";
import { UserProfile } from "src/app/models/UserProfile";
import { AuthService } from "src/app/services/auth.service";
import { CompanyService } from "src/app/services/company.service";
import { ModalComponent, ModalService } from "src/app/services/modal.service";

@Component({
  selector: "user-settings",
  templateUrl: "./user-settings.component.html",
  styleUrls: ["./user-settings.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UserSettingsComponent implements OnDestroy, ModalComponent<UserSettingsComponent> {
  private readonly _destroying$ = new Subject<void>();
  public isVisible = false;
  public user: UserProfile;

  faSpinner = faSpinner;
  localizationConstants = LocalizationConstants;
  routeNameConstants = RouteNameConstants;
  departmentFilterType = DepartmentFilterType;
  constructor(
    private authService: AuthService,
    public modalService: ModalService,
    public companyService: CompanyService,
    private router: Router,
    public dialogRef: MatDialogRef<UserSettingsComponent, void>,
  ) {
    this.isVisible = this.authService.isLoggedIn;
    this.onUserChange();
  }

  private onUserChange(): void {
    this.authService.userProfile$.pipe(takeUntil(this._destroying$)).subscribe({
      next: (user) => {
        if (user) {
          this.user = user;
        }
      },
    });
  }

  navigate(route: string) {
    this.modalService.close();
    this.router.navigate([route]);
  }

  logout() {
    this.modalService.close();
    this.authService.logout();
  }

  // Not clear from Angular documentation
  // how to get ref to MatAutocompleteTrigger using ViewChild
  // reference: https://stackoverflow.com/a/66729264
  openPanel(trigger: MatAutocompleteTrigger) {
    !trigger.panelOpen && trigger.openPanel();
  }

  // TODO: Fix initial department selection not working - always AllDepartments is selected

  onCompanySelectInput(event: Event) {
    this.companyService.companyInput$.next((event.target as HTMLInputElement).value);
  }

  onDepartmentSelectionChange(department: Department) {
    this.companyService.onDepartmentSelectionChange(department);
  }

  companyAutocompleteDisplayFn(company: Company) {
    return company ? company.fullName : "";
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
